export const cssConstants = {
  tabletWidthBreakPoint: 768,
  desktopWidthBreakPoint: 1200,
}
